import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const MetaPixel = () => {
  useEffect(() => {
    // Initialize Meta Pixel
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your Pixel ID
    fbq('init', '1485525869566246');
    // Track PageView on initial load
    fbq('track', 'PageView');
    // Clean up function not needed as Meta Pixel should persist
  }, []);
  return <noscript data-id="element-78">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1485525869566246&ev=PageView&noscript=1" alt="" data-id="element-79" />
    </noscript>;
};
export default MetaPixel;